import React, { useState } from 'react';
import { DocumentListPotentialClients } from '../../Components/PotentialClients/DocumentList';
import { StepThree } from '../../types/PrekapiDocuments/PrekapiDocuments';
import { TableFilesSyntage } from '../../Components/PotentialClients/Syntage/TableFilesSyntage';

interface FilesSyntageSectionProps {
  stepThree?: StepThree;
}

export const FilesSyntageSection = ({
  stepThree,
}: FilesSyntageSectionProps) => {
  const [isOnReview, setIsOnReview] = useState(false);
  const [showReview, setShowReview] = useState(true);
  return (
    <DocumentListPotentialClients
      title='Paso 3: Syntage'
      onReview={setIsOnReview}
      showReview={showReview}
    >
      <TableFilesSyntage stepThree={stepThree} isOnReview={isOnReview} handleShow={() => setShowReview(false)} />
    </DocumentListPotentialClients>
  );
};
